// src/hooks/usePageTracking.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@util/ga";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (/^\/tribute\/manage\/?$/i.test(location.pathname)) return;
    // Log a page view whenever the location changes
        trackPageView(location.pathname + location.search);
    }, [location]);
}
